import { CustomButton } from '@Modules/core/components';
import { Center, Skeleton, Checkbox } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TOrdersDatatableData = {
    primaryKey: string | number,
    creationDate: string,
    order: string,    
    reason: string,
    tag: string,
    oldValue: string,
    newValue: string,
    status: string,
    active: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TOrdersDatatableData>()

export function getOrdersDatatableColumns({ isLoading, handleEdit }: Props) {
  
  return [
    
    columnHelper.accessor("creationDate",
        {
            id: "creationDate",
            header: "Date creation",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("order",
        {
            id: "order",
            header: "Commande",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),  
    columnHelper.accessor("reason",
        {
            id: "reason",
            header: "Motif",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("tag",
        {
            id: "tag",
            header: "Tag",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("oldValue",
        {
            id: "oldValue",
            header: "Ancienne valeur",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),  
    columnHelper.accessor("newValue",
        {
            id: "newValue",
            header: "Nvelle Valeur",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "status",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),

    columnHelper.accessor("active",
        {
            id: "active",
            header: "Actif",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Checkbox checked={!!props.getValue()} readOnly></Checkbox>
                </Skeleton>)
            },
        }
    ),


    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Edit
                        </CustomButton>                        
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
